export function renderDownloadConfirmContent(): JSX.Element {
  return (
    <div>
      <div>确定下载该模版吗？</div>
      <div style={{ marginTop: 8, color: '#1fcdb6' }}>
        下载后请及时保存。若您使用会员权益下载，重复下载将消耗新的次数。
      </div>
    </div>
  )
}
